import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8a4f31b4"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "viewContactsMainConatiner" };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = { class: "flex flex-row items-center mb-[15px]" };
const _hoisted_4 = { class: "text-[#101828] font-medium" };
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("span", { class: "text-error-600" }, "*", -1));
const _hoisted_6 = {
    key: 0,
    class: "mt-2 text-red-40 flex text-error-600"
};
const _hoisted_7 = {
    key: 1,
    class: "flex flex-row items-center mb-[15px]"
};
const _hoisted_8 = { class: "text-[#101828] font-medium" };
const _hoisted_9 = {
    id: "book-appointment-add-guests-button",
    class: "text-primary-700 font-medium mt-[2px]"
};
const _hoisted_10 = { key: 3 };
const _hoisted_11 = { class: "flex flex-row cursor-pointer items-center mt-3 w-fit" };
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "text-[#101828] font-medium mt-[2px]" }, "Guest(s) count", -1));
const _hoisted_13 = {
    key: 0,
    class: "text-error-700 mt-2 mb-2 flex text-sm"
};
const _hoisted_14 = { key: 4 };
const _hoisted_15 = {
    key: 0,
    class: "mt-[20px]"
};
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "border-[0.5px] border-l-[0.2px] border-gray-200 h-auto" }, null, -1));
const _hoisted_17 = { class: "flex flex-row items-center mt-[10px]" };
const _hoisted_18 = { class: "text-[#101828] font-medium mt-[2px]" };
const _hoisted_19 = ["id"];
const _hoisted_20 = { class: "flex flex-row justify-between w-[87%]" };
const _hoisted_21 = { class: "flex w-[60%] flex-col leading-3 pl-[5px]" };
const _hoisted_22 = { class: "ml-1" };
const _hoisted_23 = {
    key: 0,
    class: "text-[11px] text-gray-700 mt-1"
};
const _hoisted_24 = {
    key: 1,
    class: "text-[11px] text-gray-700 mt-1"
};
const _hoisted_25 = {
    key: 2,
    class: "text-[11px] text-gray-700 mt-1"
};
const _hoisted_26 = { class: "flex flex-row justify-center items-center" };
const _hoisted_27 = ["innerHTML"];
const _hoisted_28 = { class: "ml-2 cursor-pointer" };
const _hoisted_29 = { class: "ml-2 cursor-pointer" };
const _hoisted_30 = {
    key: 1,
    class: "mt-[20px]"
};
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "border-[0.5px] border-l-[0.2px] border-gray-200 h-auto" }, null, -1));
const _hoisted_32 = { class: "flex flex-row items-center mt-[10px]" };
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "text-[#101828] font-medium mt-[2px]" }, "Guest(s)", -1));
const _hoisted_34 = { key: 5 };
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "border-[0.5px] border-l-[0.2px] border-gray-200 h-auto mt-[20px]" }, null, -1));
const _hoisted_36 = {
    key: 0,
    class: "flex flex-row items-center mt-2"
};
const _hoisted_37 = { class: "flex w-[87%] flex-col leading-3 pl-[5px]" };
const _hoisted_38 = { class: "ml-1" };
const _hoisted_39 = {
    class: "text-sm font-medium leading-5",
    id: "contact-details-container-guestCount"
};
import { convertAndFormatSource } from '@/helper/helper';
import AppState from '@/states/book_appointment';
import { InfoCircleIcon, LinkExternal01Icon, User01Icon, Users02Icon, UsersPlusIcon, XCloseIcon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIAvatar, UIInputNumber, UITooltip } from '@gohighlevel/ghl-ui';
import { computed, ref } from 'vue';
import UserDetails from '../common/UserDetails.vue';
import AddGuest from './AddGuest.vue';
import SearchContacts from './SearchContacts.vue';
import { appointmentWizardState, bookRecurring, contactTimezone, disableContactTimezone, selectedCalendar, shouldCollectGuestCountOnly, shouldCollectGuestInfo, showCountError, slotInContactTimezone, } from './appointmentWizardState';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ViewContacts',
    setup(__props) {
        const showAddGuestModal = ref(false);
        const selectedContacts = computed(() => {
            return [AppState.selectedContact];
        });
        const toggleAddGuestModal = () => {
            showAddGuestModal.value = !showAddGuestModal.value;
        };
        const attendeeCount = computed(() => {
            let count = 1 + appointmentWizardState.guestsRef.length;
            if (appointmentWizardState.guestCount) {
                count += appointmentWizardState.guestCount;
            }
            return `${count} ${count === 1 ? 'attendee' : 'attendees'}`;
        });
        const tooltip = () => {
            return `Source : ${convertAndFormatSource(AppState.source)} <br> Booked By: ${'-'}  `;
        };
        const showContactTimezone = computed(() => {
            var _a;
            return (!bookRecurring.value &&
                !((_a = selectedCalendar === null || selectedCalendar === void 0 ? void 0 : selectedCalendar.value) === null || _a === void 0 ? void 0 : _a.isClassBookingCalendar) &&
                (appointmentWizardState.appointmentSlots.length ||
                    AppState.calendarPageData.startTime) &&
                slotInContactTimezone.value.startTime &&
                slotInContactTimezone.value.startTime !== 'Invalid date' &&
                !disableContactTimezone.value);
        });
        const redirectToContacts = () => {
            const routeData = AppState.router.resolve({
                name: 'contact_detail-v2',
                params: { contact_id: AppState.selectedContact.id },
            });
            window.open(routeData.href, '_blank');
        };
        // Function to remove a guest based on its index in guestsRef
        const removeGuest = (index) => {
            var _a;
            // Use splice to remove the guest at the specified index from guestsRef
            (_a = appointmentWizardState.guestsRef) === null || _a === void 0 ? void 0 : _a.splice(index, 1);
        };
        const selectedContactName = computed(() => {
            var _a, _b;
            return ((_a = AppState.selectedContact) === null || _a === void 0 ? void 0 : _a.name) || ((_b = AppState.selectedContact) === null || _b === void 0 ? void 0 : _b.email);
        });
        return (_ctx, _cache) => {
            var _a, _b;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", _hoisted_1, [
                    (_unref(AppState).showBlockedTimeAndContact && !_unref(AppState).isEdit)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", {
                                class: "selectContactContainer",
                                style: _normalizeStyle({
                                    border: _unref(appointmentWizardState).contactError
                                        ? '1px solid var(--error-600)'
                                        : '1px solid var(--gray-200)',
                                })
                            }, [
                                _createElementVNode("div", _hoisted_3, [
                                    _createVNode(_unref(User01Icon), { class: "w-5 h-5 text-gray-500 mr-2" }),
                                    _createElementVNode("div", _hoisted_4, [
                                        _createTextVNode(_toDisplayString(_ctx.$t('appointmentModal.select_contact')) + " ", 1),
                                        _hoisted_5
                                    ])
                                ]),
                                _createVNode(SearchContacts, {
                                    "is-add-contact": true,
                                    screen: "add-appointment"
                                })
                            ], 4),
                            (_unref(appointmentWizardState).contactError)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(appointmentWizardState).contactError), 1))
                                : _createCommentVNode("", true)
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_unref(Users02Icon), { class: "w-5 h-5 text-gray-500 mr-2" }),
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(attendeeCount)), 1)
                        ])),
                    (_unref(shouldCollectGuestInfo))
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: "flex flex-row cursor-pointer bg-primary-50 rounded-lg py-[6px] px-[12px] items-center mt-3 w-fit",
                            onClick: toggleAddGuestModal
                        }, [
                            _createVNode(_unref(UsersPlusIcon), { class: "w-5 h-5 text-primary-700 mr-2" }),
                            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('addGuests.add_guests')), 1)
                        ]))
                        : (_unref(shouldCollectGuestCountOnly))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                    _createVNode(_unref(Users02Icon), { class: "w-5 h-5 text-gray-500 mr-2" }),
                                    _hoisted_12
                                ]),
                                _createVNode(_unref(UIInputNumber), {
                                    class: "mt-2",
                                    modelValue: _unref(appointmentWizardState).guestCount,
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_unref(appointmentWizardState).guestCount) = $event)),
                                    id: "calendar-guest-count",
                                    placeholder: _ctx.$t('addGuests.add_guest_count')
                                }, null, 8, ["modelValue", "placeholder"]),
                                (_unref(showCountError))
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t('addGuests.guest_count_error')), 1))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true),
                    (!_unref(AppState).isEdit)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            (_unref(AppState).selectedContact)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                    _hoisted_16,
                                    _createElementVNode("div", _hoisted_17, [
                                        _createVNode(_unref(User01Icon), { class: "w-5 h-5 text-gray-500 mr-2" }),
                                        _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('appointmentModal.contact')), 1)
                                    ]),
                                    _createElementVNode("div", {
                                        class: "flex flex-row items-center mt-3",
                                        id: 'appointmentModal-contact-container-' + ((_a = _unref(AppState).selectedContact) === null || _a === void 0 ? void 0 : _a.id)
                                    }, [
                                        _createVNode(_unref(UIAvatar), { class: "bg-gray-100 mr-2" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(User01Icon), { class: "w-5 h-5 text-gray-700" })
                                            ]),
                                            _: 1
                                        }),
                                        _createElementVNode("div", _hoisted_20, [
                                            _createElementVNode("div", _hoisted_21, [
                                                _createElementVNode("div", _hoisted_22, [
                                                    _createElementVNode("div", {
                                                        class: "text-sm font-medium leading-5 cursor-pointer",
                                                        id: "contact-details-container",
                                                        onClick: redirectToContacts
                                                    }, _toDisplayString(_unref(selectedContactName)), 1),
                                                    (_unref(showContactTimezone))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(_unref(slotInContactTimezone).startTime) + " - " + _toDisplayString(_unref(slotInContactTimezone).endTime), 1))
                                                        : _createCommentVNode("", true),
                                                    (_unref(showContactTimezone))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.$t('addContact.contact_local_time')), 1))
                                                        : _createCommentVNode("", true),
                                                    (_unref(showContactTimezone))
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, " (" + _toDisplayString(_unref(contactTimezone)) + ") ", 1))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]),
                                            _createElementVNode("div", _hoisted_26, [
                                                _createVNode(_unref(UITooltip), null, {
                                                    trigger: _withCtx(() => {
                                                        var _a;
                                                        return [
                                                            _createVNode(_unref(InfoCircleIcon), {
                                                                class: "w-5 cursor-pointer",
                                                                id: 'appointmentModal-contact-container-contact-info-icon-' +
                                                                    ((_a = _unref(AppState).selectedContact) === null || _a === void 0 ? void 0 : _a.id)
                                                            }, null, 8, ["id"])
                                                        ];
                                                    }),
                                                    default: _withCtx(() => [
                                                        _createElementVNode("p", {
                                                            innerHTML: tooltip()
                                                        }, null, 8, _hoisted_27)
                                                    ]),
                                                    _: 1
                                                }),
                                                _createElementVNode("div", _hoisted_28, [
                                                    _createVNode(_unref(LinkExternal01Icon), {
                                                        class: "w-5 text-gray-700",
                                                        onClick: redirectToContacts,
                                                        id: 'appointmentModal-contact-container-contact-redirect-icon-' +
                                                            ((_b = _unref(AppState).selectedContact) === null || _b === void 0 ? void 0 : _b.id)
                                                    }, null, 8, ["id"])
                                                ]),
                                                _createElementVNode("div", _hoisted_29, [
                                                    _createVNode(_unref(XCloseIcon), {
                                                        class: "w-5 text-gray-700",
                                                        onClick: _cache[1] || (_cache[1] = ($event) => (_unref(AppState).selectedContact = undefined)),
                                                        id: "contact-details-delete"
                                                    })
                                                ])
                                            ])
                                        ])
                                    ], 8, _hoisted_19)
                                ]))
                                : _createCommentVNode("", true),
                            (_unref(appointmentWizardState).guestsRef.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _hoisted_31,
                                    _createElementVNode("div", _hoisted_32, [
                                        _createVNode(_unref(Users02Icon), { class: "w-5 h-5 text-gray-500 mr-2" }),
                                        _hoisted_33
                                    ]),
                                    _createVNode(UserDetails, {
                                        contacts: _unref(appointmentWizardState).guestsRef,
                                        class: "mt-[10px]",
                                        "show-delete": true,
                                        "on-click-delete": removeGuest,
                                        source: _unref(AppState).source,
                                        router: _unref(AppState).router
                                    }, null, 8, ["contacts", "source", "router"])
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_34, [
                            _hoisted_35,
                            _createVNode(UserDetails, {
                                contacts: _unref(selectedContacts),
                                class: "mt-[10px]",
                                "user-type": "Primary Contact",
                                "show-redirect-icon": true,
                                router: _unref(AppState).router,
                                source: _unref(AppState).source
                            }, null, 8, ["contacts", "router", "source"]),
                            _createVNode(UserDetails, {
                                contacts: _unref(appointmentWizardState).guestsRef,
                                "user-type": "Guest",
                                "show-delete": true,
                                "on-click-delete": removeGuest,
                                source: _unref(AppState).source,
                                router: _unref(AppState).router
                            }, null, 8, ["contacts", "source", "router"]),
                            (_unref(appointmentWizardState).guestCount)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    _createVNode(_unref(UIAvatar), { class: "bg-gray-100 mr-2" }, {
                                        default: _withCtx(() => [
                                            _createVNode(_unref(User01Icon), { class: "w-5 h-5 text-gray-700" })
                                        ]),
                                        _: 1
                                    }),
                                    _createElementVNode("div", _hoisted_37, [
                                        _createElementVNode("div", _hoisted_38, [
                                            _createElementVNode("div", _hoisted_39, " +" + _toDisplayString(_unref(appointmentWizardState).guestCount) + " guests ", 1)
                                        ])
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                ]),
                (showAddGuestModal.value)
                    ? (_openBlock(), _createBlock(AddGuest, {
                        key: 0,
                        "show-modal": showAddGuestModal.value,
                        "on-click-close": toggleAddGuestModal
                    }, null, 8, ["show-modal"]))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
